import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const PURCHASES = [{
  name: 'Claudia',
  city: 'Rosario'
}, {
  name: 'Patricia',
  city: 'Mendoza'
}, {
  name: 'Gabriela',
  city: 'Tucumán'
}, {
  name: 'Silvia',
  city: 'Mar del Plata'
}, {
  name: 'Andrea',
  city: 'La Plata'
}, {
  name: 'Romina',
  city: 'Córdoba'
}, {
  name: 'Daniela',
  city: 'Salta'
}, {
  name: 'Florencia',
  city: 'Santa Fe'
}, {
  name: 'Natalia',
  city: 'Neuquén'
}, {
  name: 'Valeria',
  city: 'Bahía Blanca'
}, {
  name: 'María',
  city: 'Buenos Aires'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 2000);
    // Cycle logic
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      // Wait for exit animation then change content and show again
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        // Random delay before showing next one (between 4s and 8s after dismiss)
        setTimeout(() => {
          setIsVisible(true);
        }, Math.random() * 4000 + 4000);
      }, 1000);
    }, 12000); // Total cycle time
    // Auto dismiss current one after 4 seconds
    const dismissInterval = setInterval(() => {
      if (isVisible) {
        setIsVisible(false);
      }
    }, 12000 + 4000); // Sync doesn't matter much as logic is handled above, but we need a way to close it if it stays open.
    // Actually, simpler logic:
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
      clearInterval(dismissInterval);
    };
  }, []);
  // Simpler effect for visibility toggling
  useEffect(() => {
    if (isVisible) {
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
      return () => clearTimeout(hideTimer);
    }
  }, [isVisible]);
  const purchaser = PURCHASES[currentIndex];
  return <AnimatePresence data-id="element-191">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-40 max-w-xs w-full bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-center gap-3" data-id="element-192">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-193">
            <CheckCircle2Icon className="w-6 h-6 text-green-600" data-id="element-194" />
          </div>
          <div data-id="element-195">
            <p className="text-sm font-bold text-gray-900" data-id="element-196">
              {purchaser.name} de {purchaser.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-197">
              acaba de comprar el Mega Pack
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-198">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}